<template>
  <div :style="styles">
    <b-container class="text-center my-5">
      <b-row>
        <b-col class="trusted-text mb-3">{{ title }}</b-col>
      </b-row>
      <b-row>
        <b-container class="text-center">
          <b-row>
            <BrandsBlock :brands="brands" :height="height" />
          </b-row>
        </b-container>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import BrandsBlock from '@/components/Common/BrandsBlock';

export default {
  name: 'Brands',
  components: {
    BrandsBlock
  },
  props: {
    title: {
      type: String,
      required: true
    },
    brands: {
      type: Array,
      required: true
    },
    height: {
      type: Number,
      required: false,
      default: 0
    },
    margin: {
      type: Number,
      required: false,
      default: 0
    }
  },
  computed: {
    styles() {
      return this.margin ? `margin: ${this.margin}px;` : '';
    }
  }
};
</script>

<style lang="scss" scoped>
.trusted-text {
  font-weight: 500;
  font-size: 1.3em;
  color: $strongGray;
}
</style>
